import docStore from "~/stores/document";
import { Button } from "~/components/ui/button";
import { observer } from "mobx-react";
import paths from "~/paths";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const BackToSearchResultsButton = observer(() => {
  const navigate = useNavigate();
  const prevQuery = docStore.prevQuery;
  if (prevQuery === null) return null;
  return (
    <Button variant="secondary" onClick={() => navigate(paths.construct.browse(prevQuery))}>
      <ArrowLeft />
      Back to search results
    </Button>
  );
});

export default BackToSearchResultsButton;
